import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_cdfce993-612e-4617-ac7b-89da32b19bd7/artifacts/wcwsdulx_Logo%20benchory.png";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur');
    }
    setLoading(false);
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] p-6" data-testid="forgot-password-sent">
        <div className="max-w-md w-full text-center">
          <img src={LOGO_URL} alt="BENCHORY" className="h-12 mx-auto mb-8" />
          <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8">
            <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4">
              <CheckCircle size={32} className="text-emerald-600" />
            </div>
            <h1 className="text-xl font-bold text-[#1B2A4A] font-manrope mb-2">Email envoyé</h1>
            <p className="text-gray-500 text-sm mb-2">
              Si l'adresse <strong>{email}</strong> est associée à un compte, vous recevrez un lien de réinitialisation.
            </p>
            <p className="text-gray-400 text-xs mb-6">
              Vérifiez aussi vos spams. Le lien est valable 1 heure.
            </p>
            <Link to="/login" className="inline-flex items-center gap-2 text-[#B8860B] font-semibold text-sm hover:underline">
              <ArrowLeft size={16} /> Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] p-6" data-testid="forgot-password-page">
      <div className="max-w-md w-full">
        <div className="flex justify-center mb-8">
          <img src={LOGO_URL} alt="BENCHORY" className="h-12" />
        </div>
        <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8">
          <h1 className="text-2xl font-bold text-[#1B2A4A] font-manrope mb-1" data-testid="forgot-password-title">Mot de passe oublié</h1>
          <p className="text-gray-400 text-sm mb-6">Entrez votre adresse email pour recevoir un lien de réinitialisation</p>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6 text-sm" data-testid="forgot-password-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">Adresse email</label>
              <input
                data-testid="forgot-password-email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full h-10 rounded-lg border border-gray-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#1B2A4A]"
                placeholder="votre@email.fr"
                required
              />
            </div>
            <button
              data-testid="forgot-password-submit"
              type="submit"
              disabled={loading}
              className="w-full h-11 bg-[#1B2A4A] text-white rounded-lg font-semibold text-sm hover:bg-[#152039] transition-all shadow-md disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {loading ? <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : <><Mail size={16} /> Envoyer le lien</>}
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/login" className="text-sm text-gray-400 hover:text-[#1B2A4A] inline-flex items-center gap-1">
              <ArrowLeft size={14} /> Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
